import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { getLocalLicenseQueryKey } from "../queryKeys";
import api from "../api";
import { show } from "../../../notifications/notifications";
import { NotificationsLevel } from "../../../lib/enums";
import {
  checkIsLicenseValidOrOnline,
  formatExpiryDate,
  isLicenseExpiring
} from "../utils";

const useLocalLicense = () => {
  const {
    data: localLicenseData,
    isPending: isLocalLicenseLoading,
    isError: isLocalLicenseError
  } = useQuery({
    queryKey: getLocalLicenseQueryKey,
    queryFn: api.getLocalLicense
  });

  useEffect(() => {
    if (isLocalLicenseError) {
      show({
        level: NotificationsLevel.ERROR,
        message: "Error while fetching license..."
      });
    }
  }, [isLocalLicenseError]);

  const localLicenseFormatted = {
    ...localLicenseData?.data,
    expiryDate: formatExpiryDate(localLicenseData?.data?.expiryDate)
  };

  return {
    localLicense: localLicenseFormatted,
    isLocalLicenseLoading,
    isLocalLicenseValidOrOnline: checkIsLicenseValidOrOnline(
      localLicenseFormatted?.status
    ),
    isLocalLicenseExpiring: isLicenseExpiring(
      localLicenseFormatted?.status,
      localLicenseFormatted?.expiryDate
    )
  };
};

export default useLocalLicense;
